import { Type } from '@sinclair/typebox';
export const InboxDocumentSchema = Type.Object({
    id: Type.String(),
    receivedAt: Type.String(),
    createdAt: Type.String(),
    sender: Type.String(),
    subject: Type.Union([Type.String(), Type.Null()]),
    filename: Type.String(),
    contentType: Type.String(),
    size: Type.Number(),
    isLinked: Type.Boolean(),
});
export const InboxListResponseSchema = Type.Array(InboxDocumentSchema);
export const InboxDocumentDetailSchema = Type.Composite([
    InboxDocumentSchema,
    Type.Object({
        blob: Type.String(),
    }),
]);
export const InboxDocumentParamsSchema = Type.Object({
    id: Type.String(),
});
